module.exports = __webpack_public_path__ + "img/recommend.5c1f0f2.png";